// Brand-system design tokens, scoped to the visit report page (#28).
// The page migrates to the brand charter (AronVF titles + brand colours)
// WITHOUT touching the global theme (src/styles/theme.jsx) — the global
// header/footer stay on LTSaeada / #1D1D1D (mismatch accepted, spec §2).
// Values are the verbatim hex from spec §8; used directly in the page's
// styled-components so nothing leaks into the rest of the app.
export const RJ = {
  green: '#d5ff4f',
  blue: '#595fe7',
  dark: '#314959',
  text: '#314959',
  textSecondary: '#83a7c3',
  border: '#e2e8f0',
  bg: '#f8f9fa',
  white: '#ffffff',

  greenPastel: '#e9ffcd',
  bluePastel: '#ddedff',
  orangePastel: '#ffdfcf',
  purplePastel: '#ede1ff',

  // Status dots. Orange is reserved for illustrations + the "to_repair" dot
  // only — never as a full background or text colour (spec §8).
  dotRepair: '#ff8b3d',
  dotMonitorPill: '#595fe7', // row pill dot (spec §6.4)
  dotMonitorChip: '#9aa0ff', // band counter chip dot (spec §6.2)
  dotOk: '#d5ff4f',

  radiusMd: '12px',
  radiusLg: '20px',
  radiusCard: '24px',
  radiusButton: '30px',
  radiusFull: '9999px',
  shadowCard: '0 4px 16px rgba(49, 73, 89, 0.08)',
};

// Title font for the report page (h1 + bike h2). Falls back to the existing
// global display font then sans-serif while AronVF swaps in.
export const TITLE_FONT = "'AronVF', 'AronVFVF', sans-serif";

export default RJ;
